import React, { SetStateAction } from 'react';
import CustomButton from '../CustomButton';
import { IStatusDetail, ITotal, SelectedOptionsType } from 'types/quote';
import { jsonAxios } from 'components/axios';
import { toast } from 'react-toastify';
import { sendTeamRoom } from 'components/nateon';
import { useGetUser } from 'atom/user';
import { countryCodeToEmoji, getKoreaDateTime, pointCountry } from 'components/function';

interface IConfrimDialog {
    isOpen: boolean,
    quoteId: string | null,
    data: IStatusDetail,
    setIsOpen: React.Dispatch<SetStateAction<boolean>>,
    selectedOptions: SelectedOptionsType
    setOpenDone: React.Dispatch<SetStateAction<boolean>>,
}

const QuoteConfrim = ({ isOpen, setIsOpen, data, quoteId, selectedOptions, setOpenDone }: IConfrimDialog) => {
    const user = useGetUser();
    const convertTotalPrice = (price: string): ITotal[] => {
        if (price) {
            const validJson = price.replace(/'/g, '"');
            const parsed: ITotal[] = JSON.parse(validJson);
            return parsed ? parsed.filter(arr => !arr.currency.includes('Cost')) : []
        }
        else {
            return []
        }
    }

    const confrimQuote = () => {
        if (!quoteId) return
        const optionIds = Object.values(selectedOptions).map(option => option.id);
        const reqData = {
            optionIds: optionIds,
        }
        console.log(reqData)
        jsonAxios.post(`quote/${quoteId}/option/select`, reqData).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                setIsOpen(false)
                setOpenDone(true)
                sendTeamRoom('quoteConfirm', `📦 Pulse On Ship 견적 확정❗️\n
견적ID: ${data.quoteId}
확정일시: ${getKoreaDateTime()}
유저: ${user.username}
회사이름: ${user.companyInfo.companyNameKr}
경로: ${countryCodeToEmoji(data.originCode.slice(0, 2))} ${data.originCode} | ${data.originAddress} > ${countryCodeToEmoji(data.destinationCode.slice(0, 2))} ${data.destinationCode} | ${data.destinationAddress}
`, res.data.data.orderId)
            }
            else {
                toast.error('확정에 실패했습니다.')
            }
        })
    }

    if (!isOpen) return null;

    return (
        <div className="relative">
            <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
                <div className="bg-white shadow-lg p-10 rounded-lg w-[660px] tablet:w-96">
                    <div className='flex flex-col gap-8 font-semibold'>
                        <p className="text-2xl">
                            견적 확정
                        </p>

                        <div className='flex flex-col gap-3 text-lg text-left'>
                            <p>
                                <span dangerouslySetInnerHTML={{ __html: pointCountry(data.originCode) }}></span>
                                {' '}| {data.originAddress} &gt; {' '}
                                <span dangerouslySetInnerHTML={{ __html: pointCountry(data.destinationCode) }}></span>
                                {' '}| {data.destinationAddress}
                                <br />에 대한 견적서를 확정 선택하시겠습니까?
                            </p>

                            <div className='flex flex-col gap-2 font-medium text-sm'>
                                <div className="flex items-center bg-[#EEF4FF] rounded h-10">
                                    <div className="flex-[0.5] text-center">순서</div>
                                    <div className="flex-[1] text-center">운송견적명</div>
                                    <div className="flex-[1.5] text-center">선사/항공명</div>
                                    <div className="flex-[1] text-center">합계</div>
                                </div>

                                {Object.entries(selectedOptions)
                                    .sort(([a], [b]) => Number(a) - Number(b))  // containerId 기준 오름차순 정렬
                                    .map(([containerId, option], index) => (
                                        <div
                                            key={containerId}
                                            className="flex items-center border border-[#E1E1E8] rounded h-15 text-center"
                                        >
                                            <div className='flex flex-[0.5] justify-center items-center'>
                                                <p className='flex justify-center items-center bg-primary rounded-full w-4.5 h-4.5 text-white text-xs'>{index + 1}</p>
                                            </div>
                                            <div className="flex-[1]">{option.optionName}</div>
                                            <div className="flex-[1.5]">{option.carrierName}</div>
                                            <div className="flex-[1]">
                                                {convertTotalPrice(option.totalPrice).map((item, idx) => (
                                                    <div className="flex justify-center gap-3" key={idx}>
                                                        <p className="w-10">{item.currency}</p>
                                                        <p>{item.price.toLocaleString()}</p>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>

                        <div className="flex justify-end gap-4">
                            <CustomButton title={'취소'} onClick={() => {
                                setIsOpen(p => !p)
                            }} className='hover:!bg-white !border-[#9D9EB7] w-[200px] !h-15 !text-[#9D9EB7]' />
                            <CustomButton title={'확인'} onClick={confrimQuote} className={'w-[200px] !h-15 bg-primary'} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuoteConfrim;